import React, { PropsWithChildren, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { filterResetRequested } from '../../../Store/Filter/action';
import useFilterIsInitial from '../../../Hook/Interest/UseFilterIsInitial';
import { FilterTotals } from '../../../Interface/FilterTotals';

type Props = PropsWithChildren<{
    name?: string;
    filterTotals?: FilterTotals;
}>;

const Filters: React.FC<Props> = ({
    children,
    name = 'Filters',
    filterTotals
}) => {
    const dispatch = useDispatch();
    const clearFilters = useCallback(() => dispatch(filterResetRequested()), []);
    const filterIsInitial = useFilterIsInitial();

    return (
        <div className="filters">
            <h3>
                {name}
                {filterTotals !== undefined && (
                    <span className="filters__totals">{`${filterTotals.amountSelected}/${filterTotals.maxAmountSelected}`}</span>
                )}
                {!filterIsInitial && (
                    <span
                        title="Verwijder alle filter-instellingen"
                        onClick={clearFilters}
                        onKeyDown={clearFilters}
                        className="filters__clear-filters"
                    >
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.8312 14.9684L0.03125 1.16836L1.1 0.0996094L14.9 13.8996L13.8312 14.9684ZM1.25 3.99961V2.49961H2.8625V3.99961H1.25ZM3.5 7.74961V6.24961H6.6125V7.74961H3.5ZM7.11875 3.99961L5.61875 2.49961H14.75V3.99961H7.11875ZM6.5 11.4996V9.99961H9.5V11.4996H6.5ZM10.8687 7.74961L9.36875 6.24961H12.5V7.74961H10.8687Z" fill="#1C1B1F"/>
                        </svg>
                    </span>
                )}
            </h3>
            {children}
        </div>
    );
};

export default Filters;
